import React from "react"
import type {
  CategoryType,
  MonetaryValue,
  Transaction,
  TransactionSummary,
} from "@digits-graphql/frontend/graphql-bearer"
import monetaryValueHelper from "@digits-shared/helpers/monetaryValueHelper"
import moneyFlowHelper from "@digits-shared/helpers/moneyFlowHelper"
import { useOpeningEndingMoneyFlow } from "src/frontend/components/Shared/Transactions/Categories/hooks/useOpeningEndingMoneyFlow"

export const useCumulativeBalance = ({
  transaction,
  categoryType,
  summary,
}: {
  transaction: Transaction
  categoryType: CategoryType | undefined
  summary: TransactionSummary
}): MonetaryValue | null => {
  const { runningTotal } = transaction
  const { openingMoneyFlow } = useOpeningEndingMoneyFlow({ categoryType, summary })

  return React.useMemo((): MonetaryValue | null => {
    if (!runningTotal) {
      return null
    }

    return monetaryValueHelper.addValues(
      moneyFlowHelper.toMonetaryValue(runningTotal),
      moneyFlowHelper.toMonetaryValue(openingMoneyFlow)
    )
  }, [runningTotal, openingMoneyFlow])
}
